import React, { useState, useEffect, Fragment, useRef } from 'react';
import Button from "app/components/CustomButtons/Button.js";

export default function FormCO(props) {
    const [rows, setRows] = useState([{}]);
    const [rowCount, setRowCount] = useState(1);
    const [COLines, setCOLines] = useState([]);
    const myRef = useRef(null);

    useEffect(() => {
        setCOLines(props.COLDetails || []);
        setRows(props.COLDetails);
        setRowCount(props.COLDetails.length);
        myRef.current.scrollIntoView();
    }, [props.COLDetails]);

    const handleChange = idx => e => {

        let { name, value } = e.target;

        //remove digits from the name variable
        name = name.replace(/[0-9]/g, '');
        var matches = name.match(/\d+/g);
        if (matches != null) {
            console.log("There was an issue with updating COL")
        }

        const latestRows = [...rows];

        latestRows[idx] = {
            itemCode: latestRows[idx].itemCode,
            quantity: latestRows[idx].quantity,
            description: latestRows[idx].description,
            rangeDescription: latestRows[idx].rangeDescription,
            numberOfPallets: latestRows[idx].numberOfPallets,
            unitsPerPallet: latestRows[idx].unitsPerPallet,
            totalPieces: latestRows[idx].totalPieces,
            [name]: value
        };

        setRows(latestRows);
    };

    const handleAddRow = (e) => {
        const item = {
            itemCode: "",
            quantity: "",
            description: "",
            rangeDescription: "",
            numberOfPallets: "",
            unitsPerPallet: "",
            totalPieces: ""

        };
        setRows([...rows, item]);
        setRowCount(rows.length + 1);
        e.preventDefault();
    };

    const handleRemoveSpecificRow = (idx) => (e) => {
        const latestRows = [...rows]
        rows[idx].postType = "delete";
        setRows(latestRows);

        e.preventDefault();
    }

    return (
        <div ref={myRef}>
            <div className="container">
                <div className="row clearfix">
                    <div className="col-md-12 column">
                        <table
                            className="table table-bordered table-hover"
                            id="tab_logic">
                            <thead>
                                <tr>
                                    <th className="text-center">Item Code </th>
                                    <th className="text-center">Quantity</th>
                                    <th className="text-center">Description</th>
                                    <th className="text-center">Other Comments</th>
                                    <th className="text-center">Number Of Pallets</th>
                                    <th className="text-center">Units Per Pallet</th>
                                    <th className="text-center">Total Pieces</th>
                                    <th />
                                </tr>
                            </thead>
                            <tbody>
                                {rows.filter((row) => row.postType !== "delete").map((item, idx) => {
                                    console.log(idx, item);
                                    return (
                                        <Fragment key={`COLItem-${item.customerOrderLineID ?? idx}`}><input type="hidden" name={"customerOrderLineID" + idx} id={"customerOrderLineID" + idx} value={rows[idx].customerOrderLineID} className="form-control" />
                                            <input type="hidden" name={"postType" + idx} id={"postType" + idx} value={rows[idx].postType} className="form-control" />
                                            <tr id="addr0" key={idx}>
                                                <td>
                                                    <input
                                                        type="text"
                                                        name={"itemCode" + idx}
                                                        value={rows[idx].itemCode}
                                                        onChange={handleChange(idx)}
                                                        defaultValue={rows[idx].itemCode}
                                                        className="form-control"
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        name={"quantity" + idx}
                                                        value={rows[idx].quantity}
                                                        onChange={handleChange(idx)}
                                                        defaultValue={rows[idx].quantity}
                                                        className="form-control"
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        name={"description" + idx}
                                                        value={rows[idx].description}
                                                        onChange={handleChange(idx)}
                                                        defaultValue={rows[idx].description}
                                                        className="form-control"
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        name={"rangeDescription" + idx}
                                                        value={rows[idx].rangeDescription}
                                                        onChange={handleChange(idx)}
                                                        defaultValue={rows[idx].rangeDescription}
                                                        className="form-control"
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        name={"numberOfPallets" + idx}
                                                        value={rows[idx].numberOfPallets}
                                                        onChange={handleChange(idx)}
                                                        defaultValue={rows[idx].numberOfPallets}
                                                        className="form-control"
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        name={"unitsPerPallet" + idx}
                                                        value={rows[idx].unitsPerPallet}
                                                        onChange={handleChange(idx)}
                                                        defaultValue={rows[idx].unitsPerPallet}
                                                        className="form-control"
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        name={"totalPieces" + idx}
                                                        value={rows[idx].totalPieces}
                                                        onChange={handleChange(idx)}
                                                        defaultValue={rows[idx].totalPieces}
                                                        className="form-control"
                                                    />
                                                </td>
                                            </tr></Fragment>
                                    )
                                })}
                            </tbody>
                        </table>
                        <Button onClick={handleAddRow} color="blue">
                            Add Row
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}